import Footer from "../components/Footer";
import TariffTable from "../components/Tariff";
import HeroPages from "../components/HeroPages";
import corolla_1 from "../images/cars-big/bkg/corolla_1.png";
import corolla_2 from "../images/cars-big/bkg/corolla_2.png";
import civic from "../images/cars-big/bkg/civic.png";
import sienna from "../images/cars-big/bkg/sienna.png";
import camry from "../images/cars-big/bkg/camry.png";
import tesla from "../images/cars-big/bkg/tesla.png";
import { Link } from "react-router-dom";

function Models() {
  return (
    <>
      <section className="models-section">
        <HeroPages name="Vehicle Models" />
        <div className="container">
          <div className="models-div">
            <div className="models-div__box">
              <div className="models-div__box__img">
                <img src={corolla_1} alt="car_img" />
                <div className="models-div__box__descr">
                  <div className="models-div__box__descr__name-price">
                    <div className="models-div__box__descr__name-price__name">
                      <p>Toyota Corolla</p>
                    
                    </div>
                    <div className="models-div__box__descr__name-price__price">
                      <h2>$ 45 CAD/day</h2>
                    
                    </div>

                  </div>
                 
                 
                </div>
              </div>
            </div>
            <div className="models-div__box">
              <div className="models-div__box__img">
                <img src={civic} alt="car_img" />
                <div className="models-div__box__descr">
                  <div className="models-div__box__descr__name-price">
                    <div className="models-div__box__descr__name-price__name">
                      <p>Honda Civic</p>
                     
                    </div>
                    <div className="models-div__box__descr__name-price__price">
                      <h2>$45 CAD/day</h2>
                     
                    </div>
                  </div>
                 
                </div>
              </div>
            </div>
            <div className="models-div__box">
              <div className="models-div__box__img">
                <img src={camry} alt="car_img" />
                <div className="models-div__box__descr">
                  <div className="models-div__box__descr__name-price">
                    <div className="models-div__box__descr__name-price__name">
                      <p>Toyota Camry</p>
                  
                    </div>
                    <div className="models-div__box__descr__name-price__price">
                      <h2>$50 CAD/day</h2>
                    
                    </div>
                  </div>
                 
                 
                </div>
              </div>
            </div>
            <div className="models-div__box">
              <div className="models-div__box__img">
                <img src={tesla} alt="car_img" />
                <div className="models-div__box__descr">
                  <div className="models-div__box__descr__name-price">
                    <div className="models-div__box__descr__name-price__name">
                      <p>Tesla Model 3</p>
                   
                    </div>
                    <div className="models-div__box__descr__name-price__price">
                      <h2>$77 CAD/day</h2>
                      
                    </div>
                  </div>
                  
                
                </div>
              </div>
            </div>
            <div className="models-div__box">
              <div className="models-div__box__img">
                <img src={corolla_2} alt="car_img" />
                <div className="models-div__box__descr">
                  <div className="models-div__box__descr__name-price">
                    <div className="models-div__box__descr__name-price__name">
                      <p>Toyota Corolla</p>
                                         
                    </div>
                    <div className="models-div__box__descr__name-price__price">
                      <h2>$45 CAD/day</h2>
                     
                    </div>
                  </div>
                  
                  
                </div>
              </div>
            </div>

           

            <div className="models-div__box">
              <div className="models-div__box__img">
                <img src={sienna} alt="car_img" />
                <div className="models-div__box__descr">
                  <div className="models-div__box__descr__name-price">
                    <div className="models-div__box__descr__name-price__name">
                      <p>Toyota Sienna</p>
                      
                    </div>
                    <div className="models-div__box__descr__name-price__price">
                      <h2>$95 CAD/day</h2>
                    
                    </div>
                  </div>
                 
               
                </div>
              </div>
            </div>

            <div></div>
            <div className="models-div__box__descr__name-price__btn">
                    <Link onClick={() => window.scrollTo(0, 0)} to="/">
                      Book Ride
                    </Link>
                  </div>
          </div>
          
          <div className="models-section">
        <TariffTable/>
        </div>
        </div>
       
        <div className="book-banner">
          <div className="book-banner__overlay"></div>
          <div className="container">
            <div className="text-content">
              <h2>Book a car by getting in touch with us</h2>
              <span>
                <i className="fa-solid fa-phone"></i>
                <h3>+1-6478520014</h3>
              </span>
            </div>
          </div>
        </div>
        <Footer />
      
      </section>
      
    </>
  );
}

export default Models;
